<template>
    <v-card :class="{'score-default': !isSinterklaas()&&!isChristmas(), 'score-sinterklaas': isSinterklaas(), 'score-winter': isChristmas() }">
        <v-img :src="null" class="white--text align-end" :gradient="getGradient()" min-height="250">
            <div v-if="current_size != 'xs'">
                <div class="header">Week {{ $moment(new Date()).isoWeek() }}</div>    
                <div class="header-sub">{{ $moment(new Date()).format("dddd, MMMM Do YYYY") }}</div>    
            </div>
            <div v-else>
                <v-row>
                    <v-label><span class="header_font-xs">Ares</span></v-label>
                </v-row>
            </div>
            <div v-if="current_size != 'xs'">
                <v-row cols="12">
                    <v-col cols="12" offset="8">
                        <v-label><span class="white--text salutation_font">{{getSectionOfDayAndUser()}}</span></v-label>
                    </v-col>
                </v-row>
            </div>
            <div v-else>
                <v-row cols="12">
                    <v-label><span class="white--text salutation_font">{{getSectionOfDayAndUser()}}</span></v-label>
                </v-row>
            </div>
            <div v-if="current_size != 'xs'">
                <div class="flex cell-font">
                    <div class="cell1">MyBooking</div>
                    <div class="cell2">{{ this.mybooking.visitors }}</div>
                    <div class="cell3"><v-icon color="white" small class="mb-1">mdi-account</v-icon></div>
                    <div>today</div>
                </div>       
                <div class="flex cell-font">
                    <div class="cell1">MyVilla</div>
                    <div class="cell2">{{ this.myvilla.visitors }}</div>
                    <div class="cell3"><v-icon color="white" small class="mb-1">mdi-account</v-icon></div>
                    <div>today</div>
                </div>                                  
                <div class="flex cell-font">
                    <div class="cell1">Villa for You</div>
                    <div class="cell2">{{ this.online.online }}</div>
                    <div class="cell3"><v-icon color="white" small class="mb-1">mdi-home</v-icon></div>
                    <div>online</div>
                    <div v-if="this.online.new > 0" class="cell4">(+{{ this.online.new }})</div>
                </div>  
                <!-- <div class="flex cell-font">
                    <div class="cell1">Interhome</div>
                    <div class="cell2">{{ this.online.ih_online }}</div>
                    <div class="cell3"><v-icon color="white" small class="mb-1">mdi-home</v-icon></div>
                    <div>online</div>
                    <div v-if="this.online.ih_new > 0" class="cell4">(+{{ this.online.ih_new }})</div>
                </div> -->
                <v-divider color="white" class="ml-4" width="590"></v-divider>
            </div>
            <v-row cols="12" dense style="margin-bottom: 0.5px; margin-top: 0.5px;">  
                <v-col cols="8">
                    <span class="ml-4">
                        <v-btn text small v-ripple="false" v-on:click="sendRef('availability')" class="hand_pointer white--text">Occupancy</v-btn>
                        <v-btn text small v-ripple="false" v-on:click="sendRef('reviews')" class="hand_pointer white--text">Reviews</v-btn>
                        <v-btn text small v-ripple="false" v-on:click="sendRef('damages')" class="hand_pointer white--text">Damages</v-btn>
                        <v-btn text small v-ripple="false" v-on:click="sendRef('complaints')" class="hand_pointer white--text">Complaints</v-btn>
                        <v-btn text small v-ripple="false" v-on:click="sendRef('rebookings')" class="hand_pointer white--text">Rebookings</v-btn>
                        <v-btn text small v-ripple="false" v-on:click="sendRef('changes')" class="hand_pointer white--text">Changes</v-btn>
                    </span>    
                </v-col>
                <v-col cols="4" align="right" class="pr-4 pb-2">
                    <v-icon small class="icon_sync">mdi-database-sync-outline</v-icon><span class="lastupd_font-xs">{{last_update}}</span>
                </v-col>
            </v-row>
        </v-img>
    </v-card>
</template>

<script>
    
    import {bus} from "../../../../main";
    import moment from "moment";

    export default {
        computed:{
            current_size: function(){
                return this.$vuetify.breakpoint.name;
            }
        },            
        props: {
            gebr: {
                type: Object,
                default: () => ({}),
            },
            online: {
                type: Object,
                default: function(){return {};}
            },
            mybooking: {
                type: Object,
                default: function(){return {};}
            },            
            myvilla: {
                type: Object,
                default: function(){return {};}
            },                        
        },
        data() {
            return {
                last_update:'',
            }
        },
        mounted() {
            this.setLoadedDateTime();         
        },    
        created(){
            bus.$on("refresh", (data) => {
                console.log("refresh received for header " + data);
                this.setLoadedDateTime();
            });
        },
        methods: {
            isChristmas(){
                let currentDate = new Date();
                // testen: let currentDate = new Date(2024, 0, 7, 12, 30);
                let activationDate = null;
                let deActivationDate = null;
                switch (currentDate.getMonth()){
                    case 11:
                        activationDate = new Date(currentDate.getFullYear(), 11, 6, 0, 0); // always activate on december 6th (month is zerobased)
                        deActivationDate = new Date(currentDate.getFullYear() + 1, 0, 6, 0, 0); // always deactivate on january 5th next year (month is zerobased)
                        return currentDate >= activationDate && currentDate <= deActivationDate;
                    case 0:
                        activationDate = new Date(currentDate.getFullYear() - 1, 11, 6, 0, 0); // always activate on december 6th (month is zerobased)
                        deActivationDate = new Date(currentDate.getFullYear(), 0, 6, 0, 0); // always deactivate on january 5th next year (month is zerobased)
                        return currentDate >= activationDate && currentDate <= deActivationDate;         
                    default:
                        return false;       
                }   
            },      
            isSinterklaas(){
                let currentDate = new Date();
                return currentDate.getMonth() === 11 && currentDate.getDate() === 5;
            },    
            getGradient(){
                return this.isChristmas()||this.isSinterklaas()?'':'to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)'
            },  
            getSectionOfDayAndUser() {
                var hours = new Date().getHours();
                var salutation = hours < 12 ? 'Good morning ' : hours < 18 ? 'Good afternoon ' : 'Good evening ';
                return salutation += this.capitalizeFirstLetter(this.gebr.gebr_code);
            },
            capitalizeFirstLetter(param) {
                try {
                    return param[0].toUpperCase() + param.slice(1);
                } catch (err) {
                    console.log(err.message);
                }
            },
            sendRef(tag){
               bus.$emit("scroll_to",tag);
            },
            setLoadedDateTime(){
                this.last_update = moment(new Date()).format("DD-MM-YYYY HH:mm:ss"); // HH=24h hh=12h
            },
        }
    }
</script>

<style scoped>

.score-default {
    background: url('../assets/myares_banner.png') !important;
    background-size: cover !important;
}
.score-winter {
    /* remove gradient from image tag if you use this during holidays */
    background: url('../assets/santa_airborne_logo_banner.svg') no-repeat right top !important;
    background-size: cover !important;
}    
.score-sinterklaas {
    /* remove gradient from image tag if you use this during holidays */
    background: url('../assets/sinterklaas1.png') no-repeat top !important;
    background-size: 82vw 270px !important;
}    
.salutation_font {
    font-size: 25pt;
    color: white !important;
}
.header {
    font-size: 28pt !important;
    font-weight: 500;
    margin-left: 25px !important;
    color: #ECEFF1;
}
.header-sub {
    font-weight: 500;
    margin-left: 25px !important;
    color: #ECEFF1;
}
.header_font-xs {
    font-size: 40px !important;
    margin-left: 10px !important;
    color: #ECEFF1;
}    
.icon_sync{
    color: #ECEFF1;
}
.lastupd_font-xs {
    font-size: 10px !important;
    margin-left: 5px !important;
    color: #ECEFF1;
}
.hand_pointer {
    cursor: pointer;
} 
.btn-border{
    border: solid 1px white; 
}
.cell1{
    margin-left: 28px !important;
    width: 110px;
}
.cell-font{
    font-weight: 350 !important;
    font-size: 10pt !important;
}
.cell3{
    width: 20px;
}  
.cell4{
    margin-left: 8px !important;
}    
.cell2{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content:flex-end;
    margin-right: 10px;
    width: 25px;
}    
.flex{
    display: flex;
    flex-direction: row;
    align-items: center;
}
    
</style>